import React from 'react';
import { QrCode, CalendarDays, Users, MessageCircle } from 'lucide-react';
import LandingSection from './LandingSection';
import LandingStoreBadges from './LandingStoreBadges';
import MarketShot from './MarketShot';
import Reveal from './Reveal';
import { useT } from './i18n';

const highlightIcons = [QrCode, CalendarDays, Users, MessageCircle];
const gallerySrc = ['/assets/market/03.webp', '/assets/market/04.webp', '/assets/market/05.webp'];

const LandingEmployeeApp = () => {
  const t = useT();
  const highlights = t('employeeApp.highlights');
  const gallery = t('employeeApp.gallery');

  return (
    <LandingSection id="pre-zamestnancov" variant="white">
      <Reveal>
        <div className="landing-section-intro landing-section-intro--center">
          <h2 className="landing-h2">{t('employeeApp.title')}</h2>
          <p className="landing-text landing-text--center" style={{ marginBottom: 0 }}>
            {t('employeeApp.intro')}
          </p>
        </div>
      </Reveal>

      <div className="landing-showcase landing-showcase--employee">
        <Reveal>
          <div className="landing-showcase__content">
            <ul className="landing-checklist landing-checklist--grid">
              {highlights.map((item, index) => {
                const Icon = highlightIcons[index];
                return (
                  <li key={item.title} className="landing-checklist__item">
                    <span className="landing-checklist__icon">
                      <Icon size={20} strokeWidth={1.75} aria-hidden />
                    </span>
                    <span>
                      <strong className="landing-checklist__title">{item.title}</strong>
                      <span className="landing-checklist__desc">{item.description}</span>
                    </span>
                  </li>
                );
              })}
            </ul>

            <LandingStoreBadges
              divider
              label={t('employeeApp.badgesLabel')}
            />
          </div>
        </Reveal>

        <Reveal delay={0.1} className="landing-showcase__visual">
          <MarketShot
            size="hero"
            src="/assets/market/02.webp"
            alt={t('employeeApp.heroAlt')}
          />
        </Reveal>
      </div>

      <Reveal>
        <div className="landing-gallery-section landing-gallery-section--tight">
          <p className="landing-text-center landing-text--sm landing-gallery-section__label">
            {t('employeeApp.galleryLabel')}
          </p>
          <div className="landing-gallery landing-gallery--three">
            {gallery.map((screen, index) => (
              <Reveal key={gallerySrc[index]} delay={index * 0.05}>
                <figure style={{ margin: 0 }}>
                  <MarketShot size="thumb" src={gallerySrc[index]} alt={screen.alt} />
                  <figcaption className="landing-text--sm landing-text-center" style={{ marginTop: '0.75rem' }}>
                    {screen.caption}
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </Reveal>
    </LandingSection>
  );
};

export default LandingEmployeeApp;
